// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__G1AWP","img":"styles_img__rzwoF","info":"styles_info__6dtEw","success":"styles_success__bCI2D","error":"styles_error__PwN0K"};